import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PendingChange, ChangeTracker } from './change-tracker.interface';

@Injectable()
export class ChangeTrackerService implements ChangeTracker {
  private pendingChangesSubject = new BehaviorSubject<Map<string, PendingChange>>(new Map());
  public pendingChanges$ = this.pendingChangesSubject.asObservable();

  get pendingChanges(): Map<string, PendingChange> {
    return this.pendingChangesSubject.value;
  }

  hasChanges(): boolean {
    return this.pendingChanges.size > 0;
  }

  addChange(change: PendingChange): void {
    const currentChanges = new Map(this.pendingChanges);
    currentChanges.set(change.id, change);
    this.pendingChangesSubject.next(currentChanges);
  }

  removeChange(id: string): void {
    const currentChanges = new Map(this.pendingChanges);
    currentChanges.delete(id);
    this.pendingChangesSubject.next(currentChanges);
  }

  clearChanges(): void {
    this.pendingChangesSubject.next(new Map());
  }

  getChangesByType(type: PendingChange['type']): PendingChange[] {
    return Array.from(this.pendingChanges.values()).filter(change => change.type === type);
  }

  getAllChanges(): PendingChange[] {
    return Array.from(this.pendingChanges.values());
  }

  // Helper method to generate unique change IDs
  generateChangeId(prefix: string): string {
    return `${prefix}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
}
